import React from 'react';
import clsx from 'clsx';
import { hooks } from '@lifesize/clients.sdk';
import ParticipantPresentationButton from 'components/InCall/InCallParticipantList/ParticipantButtons/ParticipantPresentationButton';
import ParticipantMicButton from 'components/InCall/InCallParticipantList/ParticipantButtons/ParticipantMicButton';
import ParticipantRaisedHandButton from 'components/InCall/InCallParticipantList/ParticipantButtons/ParticipantRaisedHandButton';
import ParticipantMoreButton from 'components/InCall/InCallParticipantList/ParticipantButtons/ParticipantMoreButton';
import classes from './InCallParticipant.module.scss';

interface Props {
  participant: any;
}

const InCallParticipant = ({ participant }: Props) => {
  const userIsModerator = hooks.useIsCurrentUserModerator();
  const { dialString, isSelf, name } = participant;

  return (
    <div
      data-testid="participant-item"
      className={clsx(classes.participant, userIsModerator && classes.isModerator, isSelf && classes.isSelf)}
    >
      <div data-testid="participant-name" className={clsx(classes.name, isSelf && classes.isSelf)}>
        {name || dialString}
      </div>
      <div className={classes.buttons}>
        <ParticipantPresentationButton participant={participant} />
        <ParticipantRaisedHandButton participant={participant} />
        <ParticipantMicButton participant={participant} />
        <ParticipantMoreButton participant={participant} />
      </div>
    </div>
  );
};

export default InCallParticipant;
